import styled, { css } from 'styled-components';

export const Container = styled.div<{ error?: string }>`
  display: flex;
  flex-direction: column;
  ${({ theme, error }) => css`
    p {
      color: ${error ? theme.colors.red.main : theme.colors.white.main};
    }
  `}
`;
